module.exports = __webpack_public_path__ + "img/add-black.4de124ba.svg";